import { render, staticRenderFns } from "./StartFree.vue?vue&type=template&id=1032df0f"
import script from "./StartFree.vue?vue&type=script&lang=js"
export * from "./StartFree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports